<template>
    PurchaseView
</template>